<script>
import FBAuth from '@/utils/fb/auth.js'
import config from '@/assets/js/config'
import APIConfig from '@/assets/js/data/remote/APIConfig.js'

export default {
  name: 'authFB',
  methods: {
    authFB () {
      let clientID = config.FBClientID
      let redirectUri = APIConfig.FBRedirectUri
      let jwt = this.$services.auth.getJWT()
      let scope = config.FBScopePagesV9
      return FBAuth.openGetCodePage(clientID, redirectUri, jwt, scope).then(eventData => {
        this.$store.state.admin.Profile.FBPageName = eventData.pageName
        this.$store.state.admin.Profile.FBUserProfileName = eventData.name
        this.$store.state.admin.Profile.FBPageAccessTokenExpiredAt = eventData.pageAccessTokenExpiredAt
        this.$store.state.admin.Profile.FBAccessTokenExpiredAt = eventData.accessTokenExpiredAt
        // this.form = JSON.parse(JSON.stringify(this.$store.state.admin.Profile))
      })
      // .catch(err=>{
      //   console.error(`authFB`,err)
      // })
    }
  },
  created () {
  }
}
</script>
